import React from "react";
import { Line } from "react-chartjs-2";
import "./Graphs.css";
function LineChart(props) {
  return (
    <div className="inherit-parent-width inherit-parent-height flex-justify-content-center">
      <Line
        data={props.data}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            tooltip: {
              enabled: true,
              mode: "index",
              intersect: false,
            },
            hover: {
              mode: "nearest",
              intersect: true,
            },
            legend: {
              display: false,
              position: "top",
              labels: {
                usePointStyle: true,
                pointStyle: "circle",
                boxWidth: 20,
                boxHeight: 7,
                padding: 10,
                color: "white",
                font: {
                  size: 12,
                },
              },
            },
          },
          scales: {
            y: {
              grid: {
                position: "right",
                drawBorder: true,
                color: "#353535",
                padding: 4,
              },
              ticks: {
                beginAtZero: false,
                color: "#CFCFCF",
                padding: 0,
              },
              min: 0,
              offset: true,
            },
            x: {
              grid: {
                drawBorder: false,
                drawOnChartArea: false,
                drawTicks: false,
                color: "transparent",
                padding: 4,
              },
              ticks: {
                beginAtZero: false,
                color: "#CFCFCF",
                padding: 0,
              },
              min: 0,
              offset: true,
            },
          },
          elements: {
            point: {
              radius: (context) => {
                const index = context.dataIndex;
                const totalPoints = context.dataset.data.length;
                return index === totalPoints - 1 ? 6 : 0;
              },
              pointBackgroundColor: "white",
            },
          },
        }}
        className="height-width"
      />
    </div>
  );
}
export default LineChart;
